// Marks one event as "registration not open" on a patroller read, using the opensAt the server
// returned in a 403 manage/registration-not-open. The Roles screen then shows its normal alert.
export const applyRegistrationNotOpen = (patroller, eventId, opensAt) => ({
    ...patroller,
    signUp: { ...(patroller.signUp || {}), [eventId]: { allowed: false, opensAt: opensAt ?? null } },
});
